<template>
  <div class="content_main">
    <div class="content_main_top">
      <!-- <a-button type="primary" @click="show_pay_apply"> 报销申请 </a-button> -->
      <a-button type="primary"> 数据导出 </a-button>
    </div>
    <div class="content_main_top">
      <a-input allowClear class="a_input_self margin_self" v-model="queryParam.purchaseCode" placeholder="报销单号"
        @keyup.enter.native="query" />
      <a-input allowClear class="a_input_self margin_self" v-model="queryParam.applyUserName" placeholder="申请人"
        @keyup.enter.native="query" />
      <a-range-picker valueFormat="YYYY-MM-DD" style="margin-right: 10px; width: 240px" allowClear :value="dates"
        @change="onChange" @keyup.enter.native="query" :placeholder="['申请开始时间', '申请结束时间']" />
      <a-select placeholder="审批结果" allowClear class="a_input_self margin_self" v-model="queryParam.result"
        default-value="0" @keyup.enter.native="query">
        <a-select-option :value="''">全部</a-select-option>
        <a-select-option v-for="(val, key) in result_apply" :key="key" :value="key">{{ val.txt }}</a-select-option>
      </a-select>
      <a-select placeholder="审批状态" allowClear class="a_input_self margin_self" v-model="queryParam.status"
        default-value="0" @keyup.enter.native="query">
        <a-select-option :value="''">全部</a-select-option>
        <a-select-option v-for="(val, key) in status_apply" :key="key" :value="key">{{ val.txt }}</a-select-option>
      </a-select>
      <a-button type="primary" @click="query"> 查询 </a-button>
      <a-button type="primary" ghost @click="result"> 重置 </a-button>
    </div>
    <div class="content_main_center" id="content_main_center">
      <a-table :data-source="lis" bordered :loading="loading" :pagination="pagination" @change="handleTableChange"
        :scroll="{ y: scroll_y, scrollToFirstRowOnChange: true }">
        <a-table-column key="index" title="序号" data-index="index" width="70px">
          <template scope="text, record, index">{{
              (pagination.current - 1) * pagination.pageSize + index + 1
          }}</template>
        </a-table-column>
        <a-table-column key="applyCode" title="审批编号" ellipsis="true" data-index="applyCode" />
        <a-table-column key="applyer" title="申请人" ellipsis="true" data-index="applyer" />
        <a-table-column key="applyTime" title="申请时间" ellipsis="true" data-index="applyTime" />
        <a-table-column key="title" title="标题" ellipsis="true" data-index="title" />
        <a-table-column key="result" title="审批结果" data-index="result">
          <template scope="text">
            <span class="tag_class" :style="{ background: result_apply[text].color }">
              {{ result_apply[text].txt }}
            </span>
          </template>
        </a-table-column>
        <a-table-column key="status" title="审批状态" data-index="status">
          <template scope="text">
            <span class="tag_class" :style="{ background: status_apply[text].color }">
              {{ status_apply[text].txt }}
            </span>
          </template>
        </a-table-column>
        <a-table-column key="reimburseMap.deptName" title="隶属部门" ellipsis="true" data-index="reimburseMap.deptName" />
        <a-table-column key="totalPrice" title="总金额" ellipsis="true" data-index="totalPrice" />
        <a-table-column key="reimburseMap.name" title="户名" ellipsis="true" data-index="reimburseMap.name" />
        <a-table-column key="reimburseMap.type" title="报销类别" ellipsis="true" data-index="reimburseMap.type" />
        <a-table-column key="reimburseMap.remark" title="费用明细" ellipsis="true" data-index="reimburseMap.remark" />
        <a-table-column title="操作" width="180px">
          <template scope="text,record">
            <a @click="show_details(record)">详情</a>
            <a-divider type="vertical" />
            <a @click="handFlow(record)">历史</a>
            <a-divider type="vertical" />
            <a :disabled="record.status !== 1" @click="cancel([record.procInstId])">撤销</a>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal title="报销申请" :visible="is_show_apply" @cancel="applyClose" @ok="handleOk" width="70%"
      :maskClosable="false">
      <a-form-model :model="form" ref="ruleForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-row style="margin-bottom: 15px"><span class="form_title">表单信息</span></a-row>
        <a-row>
          <a-form-model-item label="选择抄送人" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <ccChange :data="ccC" :money="moneY" @targetKeys="getdata" v-if="isRouterAlive" />
          </a-form-model-item>
        </a-row>
        <a-row>
          <!-- <a-col :span="8">
						<a-form-model-item label="关联审批单类型">
							<a-select show-search allowClear class="margin_self" v-model="form.reimburseType" @change="changeauditCode" placeholder="请输入">
								<a-select-option :value="item.id" v-for="(item, index) in Approvallist" :key="index">
									{{ item.name }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col> -->
          <a-col :span="24">
            <a-form-model-item label="关联审批单" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <a-select show-search allowClear style="width: 200px; margin-right: 20px" v-model="approvalId"
                placeholder="关联审批单类型">
                <a-select-option :value="item.id" v-for="(item, index) in Approvallist" :key="index">
                  {{ item.name }}
                </a-select-option>
              </a-select>
              <a-button type="primary" @click="showAuditCode" :disabled="approvalId == undefined"> 关联审批 </a-button>
              <a-button type="primary" @click="showPurchase"> 关联采购 </a-button>
              <!-- <a-input allowClear v-model="form.auditCode" @click="showAuditCode" :disabled="!form.reimburseType" placeholder="请输入"></a-input> -->
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="审批单" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <div>
                <span v-for="(item, index) in auditCodeData" :key="index" class="auditItem">
                  <span @click="handelAudit(index)">{{ item.processName }}</span>
                  <a-icon class="close_icon2" @click="delete_auditCode(index)" type="close" />
                </span>
                <span v-for="(item, index) in auditCodeData2" :key="index" class="auditItem">
                  <span @click="handelAudit2(index)">{{ item.title }}</span>
                  <a-icon class="close_icon2" @click="delete_auditCode2(index)" type="close" />
                </span>
                <span v-for="(item, index) in auditCodeData3" :key="index" class="auditItem">
                  <span @click="handelAudit3(index)">{{ item.title }}</span>
                  <a-icon class="close_icon2" @click="delete_auditCode3(index)" type="close" />
                </span>
                <span v-for="(item, index) in auditCodeData4" :key="index" class="auditItem">
                  <span @click="handelAudit4(index)">{{ item.title }}</span>
                  <a-icon class="close_icon2" @click="delete_auditCode4(index)" type="close" />
                </span>
              </div>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="费用归属部门" prop="subjectionDeptId">
              <a-tree-select allowClear :treeData="deptTree" placeholder="请输入" v-model="form.subjectionDeptId"
                treeDefaultExpandAll>
              </a-tree-select>
              <!-- <a-select allowClear placeholder="请选择" v-model="form.subjectionDeptId" style="width: 267px;">
								<a-select-option :value="item.dept_id" v-for="(item, index) in deptlist" :key="index">
									{{ item.dept_name }}
								</a-select-option>
							</a-select> -->
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row v-for="(item, index) in form.reimburseDetails" :key="index">
          <a-row>
            <div class="pay_top">
              <span class="form_title">报销明细{{ index + 1 }}</span>
              <a-icon class="close_icon" @click="close_detail(index)" v-if="form.reimburseDetails.length > 1"
                type="close" />
            </div>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-model-item label="费用发生日期" :prop="'reimburseDetails.' + index + '.expenseTime'" :rules="{
                required: true,
                message: '请选择费用发生日期',
                trigger: 'change',
              }">
                <a-date-picker v-model="form.reimburseDetails[index].expenseTime" valueFormat="YYYY-MM-DD" allowClear
                  style="width: 267px" />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="报销类别" :prop="'reimburseDetails.' + index + '.types'" :rules="{
                required: true,
                message: '请选择报销类别',
                trigger: 'change',
              }">
                <a-select show-search allowClear class="margin_self" v-model="form.reimburseDetails[index].types"
                  placeholder="请输入">
                  <a-select-option :value="item.value" v-for="(item, index) in typesType" :key="index">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="报销金额(元)" :prop="'reimburseDetails.' + index + '.money'" :rules="{
                required: true,
                message: '请填写报销金额(元)',
                trigger: 'blur',
              }">
                <a-input v-model="form.reimburseDetails[index].money" type="number" @change="changeMoneyTotal"
                  placeholder="请输入"></a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item label="费用明细" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }"
                :prop="'reimburseDetails.' + index + '.remark'" :rules="{
                  required: true,
                  message: '请填写费用明细',
                  trigger: 'blur',
                }">
                <a-textarea :auto-size="{ minRows: 3, maxRows: 3 }" v-model="form.reimburseDetails[index].remark"
                  placeholder="请输入" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item label="发票号码" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }"
                :prop="'reimburseDetails.' + index + '.invoice'" :rules="{
                  required: true,
                  message: '请填写电子发票',
                  trigger: 'blur',
                }">
                <a-textarea :auto-size="{ minRows: 3, maxRows: 3 }" v-model="form.reimburseDetails[index].invoice"
                  placeholder="请输入" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-row>
        <a-row>
          <div class="btn_last">
            <a-button type="primary" @click="add_detail"> 新增报销明细 </a-button>
          </div>
        </a-row>
        <a-row style="margin-bottom: 15px"><span class="form_title">表单信息</span></a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="报销总金额" prop="reimburseMoneyTotal">
              <a-input disabled v-model="form.reimburseMoneyTotal" placeholder="请输入"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="收款账号" prop="accountNum">
              <a-select allowClear class="margin_self" v-model="form.accountNum" @change="changeform($event)"
                @dropdownVisibleChange="changeT" @blur="changeF" placeholder="请输入">
                <div slot="dropdownRender" slot-scope="menu">
                  <v-nodes :vnodes="menu" />
                  <a-divider style="margin: 4px 0" />
                  <div style="padding: 4px 8px; cursor: pointer; color: #1890ff" @mousedown="(e) => e.preventDefault()"
                    @click="alert">
                    <a-icon type="plus" /> 添加新收款账号
                  </div>
                </div>
                <a-select-option :value="item.id" v-for="(item, index) in banklist" :key="index">
                  <span style="font-weight: 700">
                    {{ item.name }}
                  </span>
                  {{ item.bank }} {{ item.accountNum }}
                  <span style="float: right; color: #1890ff" v-show="bankshow" @click="bankclear(item.id)">清除</span>
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="备注">
              <a-textarea v-model="form.remark" placeholder="请输入" :auto-size="{ minRows: 1, maxRows: 3 }" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="特殊备注">
              <a-textarea v-model="form.remarkSpec" placeholder="不能打印" :auto-size="{ minRows: 1, maxRows: 3 }" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="报销凭证" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
              <uploadImgJava :data="uploadDataImg" v-if="isRouterAlive" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="附件" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
              <uploadFileCode :data="uploadData" v-if="isRouterAlive" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>
    <!-- 图片预览 -->
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
    <!-- 关联审批单 -->
    <a-modal v-model="relavisible" title="关联审批单" @ok="relaOk" width="1000px">
      <a-table :columns="columns" :data-source="loadData" rowKey="applyCode"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, type: 'radio' }"
        :scroll="{ y: scroll_y }">
        <span slot="status" slot-scope="text" class="tag_class" :style="{ background: status_apply[text].color }">
          {{ status_apply[text].txt }}
        </span>
        <span slot="result" slot-scope="text" class="tag_class" :style="{ background: result_apply[text].color }">
          {{ result_apply[text].txt }}
        </span>
      </a-table>
    </a-modal>
    <a-modal v-model="bankvisible" title="添加新收款账户" @ok="bankOk" width="400px" style="text-align: center">
      <a-tabs default-active-key="1" @change="callback">
        <a-tab-pane key="1" tab="支付宝账号">
          <a-form-model :model="bankform" :label-col="labelCol2" :wrapper-col="wrapperCol2">
            <a-form-model-item label="户名">
              <a-input v-model="bankform.name" />
            </a-form-model-item>
            <a-form-model-item label="账号">
              <a-input v-model="bankform.accountNum" type="number" />
            </a-form-model-item>
          </a-form-model>
        </a-tab-pane>
        <a-tab-pane key="2" tab="个人银行卡">
          <a-form-model :model="bankform" :label-col="labelCol2" :wrapper-col="wrapperCol2">
            <a-form-model-item label="户名">
              <a-input v-model="bankform.name" />
            </a-form-model-item>
            <a-form-model-item label="卡号">
              <a-input v-model="bankform.accountNum" type="number" />
            </a-form-model-item>
            <a-form-model-item label="银行">
              <a-input v-model="bankform.bank" />
            </a-form-model-item>
          </a-form-model>
        </a-tab-pane>
      </a-tabs>
    </a-modal>
    <!-- 撤销提示 -->
    <a-modal v-model="is_revocation" title="确认撤销此申请吗?" on-ok="handleOkReason">
      <template slot="footer">
        <a-button key="back" @click="is_revocation = false"> 取消 </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason"> 撤销 </a-button>
      </template>
      <a-textarea placeholder="请输入原因" v-model="reason" />
    </a-modal>
    <!-- 选择审批单号 -->
    <selectAuditCode :kind="kind" :approvalId="approvalId" ref="selectAuditCode"
      :data="{ auditCodeData, auditCodeData2, auditCodeData3, auditCodeData4 }" @applyData="getAppCode"
      @applyData2="getAppCode2" @applyData3="getAppCode3" @applyData4="getAppCode4" v-if="isRouterAlive"
      @getIdData="getIdData" />
    <proc-flow-modal ref="modalflow" @ok="handleOk" />
    <business-modal ref="modal" @ok="handleOk" />
    <leave-modal ref="leavemodal" @ok="handleOk" :audit="false" />
    <purchase-modal ref="purchasemodal" @ok="handleOk" :audit="false" />
    <scrap-modal ref="scrapmodal" @ok="handleOk" :audit="false" />
    <receive-modal ref="receiveModal" @ok="handleOk" :audit="false" />
    <operation-modal ref="operationmodal" @ok="handleOk" :audit="false" />
    <service-modal ref="servicemodal" @ok="handleOk" :audit="false" />
    <reimbursement-modal ref="reimbursementmodal" @ok="handleOk" :audit="false" />
    <!-- 详情 -->
    <payMentModal ref="paymentmodal" :audit="false" />
    <!-- 详情 -->
    <contractModal ref="contractmodal" :audit="false" />
    <sealModal ref="sealmodal" @ok="handleOk" :audit="false" />
    <currencyModal ref="currencymodal" @ok="handleOk" :audit="false" />
    <returnModal ref="returnmodal" @ok="handleOk" :audit="false" />
    <car-modal ref="carmodal" @ok="handleOk" :audit="false" />
    <returncar-modal ref="returncarmodal" @ok="handleOk" :audit="false" />
    <salaryModal ref="salarymodal" @ok="handleOk" :audit="false" />
    <adjustmentModal ref="adjustmentmodal" @ok="handleOk" :audit="false" />
    <charge-modal ref="chargemodal" @ok="handleOk" :audit="false" />
    <other-modal ref="othermodal" @ok="handleOk" :audit="false" />
    <feedback-modal ref="feedbackmodal" @ok="handleOk" :audit="false" />
  </div>
</template>

<script>
// import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
// import zhCn from 'ant-design-vue/lib/locale-provider/zh_CN'
import { getDeptListEnable2 } from '@/api/system'
import { list_my, apply_code, audit_list, reimburse_apply_save } from '@/api/financial'
// import {
// 	get_dept_tree2,
// } from '@/api/assetmenag'
import {
  getBusinessListMy,
  get_accounts_receivable,
  accounts_receivable_save,
  accounts_receivable_delete,
  delProcessIns,
  modalMap,
} from '@/api/activiti'
import ccChange from '@/components/module/ccChange'
import selectAuditCode from '@/components/module/selectAuditCode.vue'
import uploadFileCode from '@/components/module/uploadFileCode.vue'
import uploadImgJava from '@/components/module/uploadImgJava.vue'

import BusinessModal from '../activiti/modules/BusinessModal.vue'
import LeaveModal from '../activiti/modules/LeaveModal.vue'
import PurchaseModal from '../activiti/modules/PurchaseModal.vue'
import ScrapModal from '../activiti/modules/ScrapModal.vue'
import receiveModal from '../activiti/modules/receiveModal.vue'
import ProcFlowModal from '../activiti/modules/ProcFlowModal.vue' //历史
import OperationModal from '../activiti/modules/OperationModal.vue'
import ServiceModal from '../activiti/modules/ServiceModal.vue'
import ReimbursementModal from '../activiti/modules/ReimbursementModal.vue'
import payMentModal from '@/views/activiti/modules/payMentModal.vue'
import contractModal from '@/views/activiti/modules/contractModal.vue'
import sealModal from '@/views/activiti/modules/sealModal.vue'
import currencyModal from '@/views/activiti/modules/currencyModal.vue'
import returnModal from '@/views/activiti/modules/returnModal.vue'
import carModal from '@/views/activiti/modules/carModal.vue'
import returncarModal from '@/views/activiti/modules/returncarModal.vue'
import salaryModal from '@/views/activiti/modules/salaryModal.vue'
import adjustmentModal from '@/views/activiti/modules/adjustmentModal.vue'
import chargeModal from '@/views/activiti/modules/chargeModal.vue'
import otherModal from '@/views/activiti/modules/otherModal.vue'
import feedbackModal from '@/views/activiti/modules/feedbackModal.vue'
export default {
  components: {
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes,
    },
    ccChange,
    selectAuditCode,
    uploadFileCode,
    uploadImgJava,
    ProcFlowModal,
    BusinessModal,
    LeaveModal,
    PurchaseModal,
    ScrapModal,
    receiveModal,
    OperationModal,
    ServiceModal,
    ReimbursementModal,
    payMentModal,
    contractModal,
    sealModal,
    currencyModal,
    returnModal,
    carModal,
    returncarModal,
    salaryModal,
    adjustmentModal,
    chargeModal,
    otherModal,
    feedbackModal,
  },
  data() {
    return {
      arrApply: [],
      arrPurshe: [],
      arrApply2: [],
      arrPurshe2: [],
      arrApply3: [],
      arrPurshe3: [],
      arrApply4: [],
      arrPurshe4: [],
      idList: {},
      deptTree: [],
      auditCodeData: [],
      auditCodeData2: [],
      auditCodeData3: [],
      auditCodeData4: [],
      rules: {
        subjectionDeptId: [
          {
            required: true,
            message: '请选择费用归属部门',
            trigger: 'change',
          },
        ],
        reimburseMoneyTotal: [
          {
            required: true,
            message: '请输入报销金额',
            trigger: 'blur',
          },
        ],
        accountNum: [
          {
            required: true,
            message: '请选择收款账号',
            trigger: 'change',
          },
        ],
      },
      scroll_y: 150,
      loading: false,
      lis: [],
      uploadData: {
        code: '',
        type: 'reimburse-appendix',
        // types: ['application/pdf', 'image/png', 'image/jpeg', 'application/vnd.ms-excel',
        // 	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        // ],
      },
      uploadDataImg: {
        code: '',
        type: 'reimburse-certificate',
      },
      labelCol2: {
        span: 3,
      },
      wrapperCol2: {
        span: 21,
      },
      labelCol3: {
        span: 2,
      },
      wrapperCol3: {
        span: 22,
      },
      bankshow: true,
      isRouterAlive: true,
      // 表头
      columns: [
        {
          title: '申请标题',
          dataIndex: 'title',
          key: 'title',
          ellipsis: true,
        },
        {
          title: '',
          dataIndex: 'procName',
          ellipsis: true,
        },
        {
          title: '当前审批环节',
          dataIndex: 'currentTask',
          ellipsis: true,
        },
        {
          title: '审批结果',
          dataIndex: 'result',
          scopedSlots: {
            customRender: 'result',
          },
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: {
            customRender: 'status',
          },
        },
        {
          title: '申请时间',
          dataIndex: 'applyTime',
          sorter: true,
          ellipsis: true,
        },
      ],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showLessItems: true,
        showSizeChanger: true,
      },
      labelCol: {
        span: 9,
      },
      wrapperCol: {
        span: 15,
      },
      is_show_apply: false,
      form: {
        cc: [],
        reimbursementCode: '',
        reimburseType: undefined,
        associateApply: [],
        reimburseMoneyTotal: '',
        remark: '',
        remarkSpec: '',
        name: '',
        accountNum: '',
        bank: '',
        reimburseDetails: [
          {
            expenseTime: '',
            types: undefined,
            money: '',
            remark: '',
          },
        ],
      },
      bankform: {
        name: '',
        accountNum: '',
        bank: '',
      },
      types: ['支付宝账号', '个人银行卡'],
      type_index: 0,
      previewVisible: false,
      previewImage: '',
      fileList: [],
      Approvallist: [],
      queryParam: {},
      dates: [],
      deptlist: [],
      // companylist: [],
      relavisible: false,
      loadData: [],
      rowvisible: false,
      rowlist: {},
      banklist: [],
      bankvalue: {},
      bankvisible: false,
      typesnum: 1,
      Select: {},
      selectedRowKeys: [],
      ccC: 'reimburse',
      moneY: '',
      is_revocation: false,
      tabid: '',
      reason: '',
      kind: undefined,
      approvalId: undefined,
      typeIndex: undefined,
    }
  },
  created() {
    // get_dept_tree2().then((res) => {
    // 	this.companylist = res.data.dept_lis
    // 	this.companylist.unshift({
    // 		dept_id: 0,
    // 		dept_name: '所有公司',
    // 		child_lis: [],
    // 	})
    // })
    getDeptListEnable2().then((res) => {
      const data = res.rows
      if (data.length > 0) {
        const min = Math.min(...data.map((m) => m.parentId))
        this.buildtree2(data, this.deptTree, this.$store.getters.userInfo.companyId)
      }
    })
    this.get_acc()
    this.get_lis()
  },
  mounted() {
    this.$nextTick(() => {
      var max_h = $('#content_main_center').height()
      setTimeout(() => {
        this.scroll_y = max_h - $('.ant-table-header').height() - 50
      }, 1000)
    })
  },
  methods: {
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.loading = true
      this.get_lis()
    },
    applyClose() {
      this.approvalId = undefined
      this.is_show_apply = false
    },
    getIdData(data) {
      this.idList = data
      console.log(data, 'data========================================')
    },
    buildtree2(list, arr, parentId) {
      list.forEach((item) => {
        if (item.parentId === parentId) {
          var child = {
            key: item.deptId,
            value: item.deptId, // value是给modal的select用的，2者属性不一样
            title: item.deptName,
            scopedSlots: {
              title: 'title',
            },
            children: [],
          }
          this.buildtree2(list, child.children, item.deptId)
          if (child.children.length === 0) {
            delete child.children
          }
          arr.push(child)
        }
      })
    },
    handelAudit(index) {
      var record = this.auditCodeData[index]
      const modal = modalMap[record.processDefKey]
      console.log(modal)
      this.$refs[modal].show({
        businessKey: record.businessKey,
      })
    },
    handelAudit2(index) {
      var record = this.auditCodeData2[index]
      const modal = modalMap[record.procDefKey]
      console.log(modal)
      this.$refs[modal].show({
        businessKey: record.businessKey,
      })
    },
    handelAudit3(index) {
      var record = this.auditCodeData3[index]
      const modal = modalMap[record.procDefKey]
      console.log(modal)
      this.$refs[modal].show({
        businessKey: record.id,
      })
    },
    handelAudit4(index) {
      var record = this.auditCodeData4[index]
      const modal = modalMap[record.procDefKey]
      console.log(modal)
      this.$refs[modal].show({
        businessKey: record.businessKey,
      })
    },
    delete_auditCode(index) {
      this.auditCodeData.splice(index, 1)
      console.log(this.auditCodeData)
    },
    delete_auditCode2(index) {
      this.auditCodeData2.splice(index, 1)
      console.log(this.auditCodeData)
    },
    delete_auditCode3(index) {
      this.auditCodeData3.splice(index, 1)
      console.log(this.auditCodeData)
    },
    delete_auditCode4(index) {
      this.auditCodeData4.splice(index, 1)
      console.log(this.auditCodeData)
    },
    cancel(ids) {
      this.is_revocation = true
      this.tabid = ids
      this.reason = ''
    },
    //撤销提交
    handleOkReason() {
      delProcessIns({
        ids: this.tabid.join(','),
        reason: this.reason,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success('撤销成功')
          this.get_lis()
          this.is_revocation = false
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handFlow(row) {
      var obj = {
        procInstId: row.procInstId,
        procDefKey: row.procDefKey,
      }
      this.$refs.modalflow.show(obj)
    },
    changeMoneyTotal() {
      this.form.reimburseMoneyTotal = 0
      this.form.reimburseDetails.forEach((item) => {
        this.form.reimburseMoneyTotal += Number(item.money)
      })
      this.form.reimburseMoneyTotal = this.form.reimburseMoneyTotal.toFixed(2)
      this.moneY = this.form.reimburseMoneyTotal
    },
    //获取code
    getAppCode(data) {
      // if(this.kind == 1) {
      // 			this.arrPurshe = data
      // 		} else {
      // 			this.arrApply = data
      // 		}
      // 	data.forEach(item => {
      // this.auditCodeData.push(item)
      // })
      this.auditCodeData = data
      console.log(
        this.auditCodeData,
        'this.auditCodeDatathis.auditCodeDatathis.auditCodeDatathis.auditCodeDatathis.auditCodeDatathis.auditCodeData'
      )
    },
    getAppCode2(data) {
      // if(this.kind == 1) {
      // 			this.arrPurshe2 = data
      // 		} else {
      // 			this.arrApply2 = data
      // 		}
      // 	data.forEach(item => {
      // this.auditCodeData2.push(item)
      // })
      this.auditCodeData2 = data
    },
    getAppCode3(data) {
      // if(this.kind == 1) {
      // 			this.arrPurshe3 = data
      // 		} else {
      // 			this.arrApply3 = data
      // 		}
      // 	data.forEach(item => {
      // this.auditCodeData3.push(item)
      // })
      this.auditCodeData3 = data
    },
    getAppCode4(data) {
      // if(this.kind == 1) {
      // 			this.arrPurshe4 = data
      // 		} else {
      // 			this.arrApply4 = data
      // 		}
      // 	data.forEach(item => {
      // this.auditCodeData4.push(item)
      // })
      this.auditCodeData4 = data
    },
    showAuditCode() {
      this.kind = 0
      this.typeIndex = 2
      // 	this.arrApply.forEach(item => {
      // 	for(var i = this.auditCodeData.length-1; i >=0 ; i--) {
      // 		if(item.businessKey == this.auditCodeData[i].businessKey) {
      // 			this.auditCodeData.splice(i,1)
      // 		}
      // 	}
      // })
      // 	this.arrApply2.forEach(item => {
      // 	for(var i = this.auditCodeData2.length-1; i >=0 ; i--) {
      // 		if(item.businessKey == this.auditCodeData2[i].businessKey) {
      // 			this.auditCodeData2.splice(i,1)
      // 		}
      // 	}
      // })
      // 	this.arrApply3.forEach(item => {
      // 	for(var i = this.auditCodeData3.length-1; i >=0 ; i--) {
      // 		if(item.businessKey == this.auditCodeData3[i].businessKey) {
      // 			this.auditCodeData3.splice(i,1)
      // 		}
      // 	}
      // })
      // 	this.arrApply4.forEach(item => {
      // 	for(var i = this.auditCodeData4.length-1; i >=0 ; i--) {
      // 		if(item.businessKey == this.auditCodeData4[i].businessKey) {
      // 			this.auditCodeData4.splice(i,1)
      // 		}
      // 	}
      // })
      this.$refs.selectAuditCode.show({
        auditCodeData: this.auditCodeData,
        auditCodeData2: this.auditCodeData2,
        auditCodeData3: this.auditCodeData3,
        auditCodeData4: this.auditCodeData4,
        typeIndex: this.typeIndex,
      })
    },
    showPurchase() {
      this.kind = 1
      // 	this.arrPurshe.forEach(item => {
      // 	for(var i = this.auditCodeData.length-1; i >=0 ; i--) {
      // 		if(item.businessKey == this.auditCodeData[i].businessKey) {
      // 			this.auditCodeData.splice(i,1)
      // 		}
      // 	}
      // })
      // 	this.arrPurshe4.forEach(item => {
      // 	for(var i = this.auditCodeData4.length-1; i >=0 ; i--) {
      // 		if(item.businessKey == this.auditCodeData4[i].businessKey) {
      // 			this.auditCodeData4.splice(i,1)
      // 		}
      // 	}
      // })
      // 	this.arrPurshe2.forEach(item => {
      // 	for(var i = this.auditCodeData2.length-1; i >=0 ; i--) {
      // 		if(item.businessKey == this.auditCodeData2[i].businessKey) {
      // 			this.auditCodeData2.splice(i,1)
      // 		}
      // 	}
      // })
      // 	this.arrPurshe3.forEach(item => {
      // 	for(var i = this.auditCodeData3.length-1; i >=0 ; i--) {
      // 		if(item.businessKey == this.auditCodeData3[i].businessKey) {
      // 			this.auditCodeData3.splice(i,1)
      // 		}
      // 	}
      // })
      this.typeIndex = 0

      console.log(this.kind, 'this.kind ====================')
      this.$refs.selectAuditCode.show({
        auditCodeData: this.auditCodeData,
        auditCodeData2: this.auditCodeData2,
        auditCodeData3: this.auditCodeData3,
        auditCodeData4: this.auditCodeData4,
        typeIndex: this.typeIndex,
      })

      console.log(this.kind, 'this.kind ====================')
      // this.$refs.selectAuditCode.show()
    },
    getdata(data) {
      this.form.cc = data
    },
    changeauditCode() {
      this.form.auditCode = ''
      this.selectedRowKeys = []
    },
    changeform(index) {
      console.log(index, 'index=========================')
      console.log(this.banklist, 'banklist==========================')
      this.bankshow = false
      this.banklist.forEach((item) => {
        if (item.id == index) {
          if (item.name == this.$store.getters.userInfo.userName) {
            this.Select = item
          } else {
            this.Select = {}
            this.form.accountNum = undefined
            this.$message.warning('请选择与当前用户名一致的账户！')
          }

        }
      })
    },
    changeF() {
      this.bankshow = false
    },
    changeT() {
      this.bankshow = true
    },
    get_acc() {
      get_accounts_receivable({
        types: 12,
      }).then((res) => {
        console.log(res.data, 1)
        this.banklist = res.data
      })
    },
    bankclear(id) {
      var that = this
      this.$confirm({
        title: '警告',
        content: '确认删除此账号?',
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          let list = []
          list.push(id)
          accounts_receivable_delete(list).then((res) => {
            if (res.code == 200) {
              that.form.accountNum = undefined
              that.get_acc()
            }
          })
        },
        onCancel() {
          console.log('Cancel')
        },
      })
    },
    callback(key) {
      this.typesnum = key
      this.bankform = {}
    },
    bankOk() {
      this.bankform['accountType'] = this.typesnum
      accounts_receivable_save(this.bankform).then((res) => {
        if (res.code == 200) {
          this.bankvisible = false
          this.get_acc()
          this.bankform = {}
        }
      })
    },
    alert() {
      this.bankvisible = true
    },
    show_details(record) {
      console.log(this.$refs.reimbursementmodal)
      this.$refs.reimbursementmodal.show({
        businessKey: record.id,
        procInstId: record.procInstId,
        procDefKey: 'reimburse',
        recordNumber: 1
      })
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    relaOk() {
      this.form.auditCode = this.selectedRowKeys[0]
      console.log(this.selectedRowKeys[0])
      this.relavisible = false
    },
    relation() {
      this.relavisible = true
      getBusinessListMy({
        result: 2,
        status: 2,
        procDefKey: this.form.reimburseType ? this.form.reimburseType.split(':')[0] : '',
      }).then((res) => {
        this.loadData = res.rows
      })
    },
    onChange(date, dateString) {
      this.dates = date
      this.queryParam.start_date = date[0]
      this.queryParam.end_date = date[1]
    },
    // costChange(index, date) {
    // 	this.form.reimburseDetails[index].expenseTime = date
    // },
    handleOk() {
      console.log('66666666666666666666666666666666')
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.form['name'] = this.Select.name
          this.form['bank'] = this.Select.bank
          this.form['accountType'] = this.Select.accountType
          this.form['accountNum'] = this.Select.accountNum
          this.form['associateApply'] = []
          this.form['associatePurchaseApply'] = []
          this.auditCodeData.forEach((item) => {
            console.log(item)
            if (item.processDefKey == 'purchase') {
              console.log('7777777777777777777777777777777')
              this.form['associatePurchaseApply'].push({
                associateTitle: item.processName,
                associateTypes: item.processDefKey,
                associateApply: item.businessKey,
                goodId: item.goodId.toString(),
                associateId: item.associateId,
              })
              console.log('7777777777777777777777777777777')
            } else {
              this.form['associateApply'].push({
                associateTitle: item.processName,
                associateTypes: item.processDefKey,
                associateApply: item.businessKey,
              })
            }
            console.log('66666666666666666666666666666666')
          })
          console.log(this.form, 'this.formthis.formthis.formthis.formthis.formthis.formthis.form')
          this.auditCodeData2.forEach((item) => {
            console.log(item)
            if (item.procDefKey == 'purchase') {
              this.form['associatePurchaseApply'].push({
                associateTitle: item.title,
                associateTypes: item.procDefKey,
                associateApply: item.businessKey,
                goodId: item.goodId.toString(),
                associateId: item.associateId,
              })
            } else {
              this.form['associateApply'].push({
                associateTitle: item.title,
                associateTypes: item.procDefKey,
                associateApply: item.businessKey,
              })
            }
          })
          this.auditCodeData3.forEach((item) => {
            console.log(item)
            if (item.procDefKey == 'purchase') {
              this.form['associatePurchaseApply'].push({
                associateTitle: item.title,
                associateTypes: item.procDefKey,
                associateApply: item.id,
                goodId: item.goodId.toString(),
                associateId: item.associateId,
              })
            } else {
              this.form['associateApply'].push({
                associateTitle: item.title,
                associateTypes: item.procDefKey,
                associateApply: item.id,
              })
            }
            console.log('66666666666666666666666666666666')
          })
          this.auditCodeData4.forEach((item) => {
            console.log(item)
            if (item.processDefKey == 'purchase') {
              this.form['associatePurchaseApply'].push({
                associateTitle: item.processName,
                associateTypes: item.processDefKey,
                associateApply: item.businessKey,
                goodId: item.goodId.toString(),
                associateId: item.associateId,
              })
            } else {
              this.form['associateApply'].push({
                associateTitle: item.processName,
                associateTypes: item.processDefKey,
                associateApply: item.businessKey,
              })
            }
          })
          this.form.cc = this.form.cc.length ? this.form.cc.join(',') : ''
          console.log('99999999999999999999999999999999')
          reimburse_apply_save(this.form).then((res) => {
            if (res.code == 200) {
              this.approvalId = undefined
              this.is_show_apply = false
              this.$message.success('新增成功')
              this.get_lis()
            } else {
              this.$message.error(res.msg)
              return
            }
          })
        }
      })
    },
    get_lis() {
      list_my({
        procDefKey: 'reimburse',
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.current,
        status: this.queryParam.status,
        result: this.queryParam.result,
        applyUserName: this.queryParam.applyUserName,
        purchaseCode: this.queryParam.purchaseCode,
        createTime1: this.queryParam.start_date,
        createTime2: this.queryParam.end_date,
        sortField: 'applyTime',
        sortOrder: 'desc',
      }).then((res) => {
        const pagination = { ...this.pagination }
        pagination.total = res.total
        this.pagination = pagination
        this.lis = res.rows
        this.loading = false
      })
    },
    //点击报销申请
    show_pay_apply() {
      this.auditCodeData = []
      this.auditCodeData2 = []
      this.auditCodeData3 = []
      this.auditCodeData4 = []
      this.is_show_apply = true
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
      this.form = {
        reimbursementCode: '',
        reimburseType: undefined,
        auditCode: '',
        reimburseMoneyTotal: '',
        remark: '',
        remarkSpec: '',
        name: '',
        accountNum: '',
        bank: '',
        reimburseDetails: [
          {
            expenseTime: '',
            types: undefined,
            money: '',
            remark: '',
          },
        ],
      }
      apply_code().then((res) => {
        console.log(res.data, 'res.data========================')
        this.form.reimbursementCode = res.data
        this.uploadData.code = res.data
        this.uploadDataImg.code = res.data
      })
      audit_list().then((res) => {
        if (res.code == 200) {
          res.data.splice(12, 1)
          this.Approvallist = res.data
        }
      })
      // this.companylist.forEach((item) => {
      // 	if (item.dept_id == this.$store.getters.userInfo.companyId) {
      // 		this.deptlist = item.child_lis
      // 	}
      // })
    },
    //新增一条明细
    add_detail() {
      this.form.reimburseDetails.push({
        expenseTime: '',
        types: undefined,
        money: '',
        remark: '',
      })
    },
    //删除明细
    close_detail(index) {
      this.form.reimburseDetails.splice(index, 1)
      this.changeMoneyTotal()
    },
    // 图片上传
    handleCancel() {
      this.previewVisible = false
    },
    async handlePreview(file) {
      console.log(file, 'file=======================')
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    handleChange({ fileList }) {
      this.fileList = fileList
    },
    //切换类型
    changeType(index) {
      this.type_index = index
    },
    query() {
      this.pagination.current = 1
      this.get_lis()
    },
    result() {
      this.queryParam = {}
      this.dates = []
    },
  },
}
</script>

<style scoped lang='less'>
.pay_top {
  width: 100%;
  float: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.form_title {
  margin-left: 15px;
  margin-bottom: 15px;
  font-size: 17px;
  color: #999;
}

.close_icon {
  font-size: 20px;
  color: red;
  cursor: pointer;
}

.close_icon2 {
  font-size: 14px;
  color: red;
  cursor: pointer;
}

.auditItem {
  border-radius: 5px;
  background-color: #f8f8f8;
  margin-left: 10px;
  color: dodgerblue;
  padding: 10px;
}

.btn_last {
  width: 100%;
  float: left;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
}

.item_top {
  width: 100%;
  float: left;

  .item {
    float: left;
    margin-right: 20px;
    cursor: pointer;
  }
}

.item_box {
  width: 100%;
  float: left;

  .boxItem {
    width: 100%;
    float: left;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 8px;

    .select {
      width: calc(100% / 2);
    }

    .itemTitle {
      width: 88px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding-right: 8px;
      box-sizing: border-box;

      .must {
        color: red;
      }
    }
  }
}
</style>
